import React, { useCallback } from 'react';
import Carousel from '@gumtree/ui-library/src/carousel/carousel';
import {
    StyleContainer,
    Card,
    Ul,
    Li,
    LiInner,
    Spacer,
    Name,
    Value,
    TabTitle,
    AdditionalFeaturesContainer,
} from './styles';
import TabContainer, { APPEND_WIDTH } from './tab-container/tab-container';
import StandardisedFeatures from '../../standardised-features/standardised-features';
import MotorsSpecs from '../motors-specs';

interface Props {
    attributeGroups: MotorsSpecs[];
}

const MobileMotorsSpecs: React.FC<Props> = ({ attributeGroups }) => (
    <StyleContainer>
        <Carousel
            itemsToShow={1}
            hasControls
            showNextSlidePreview
            isPeekWidth="265px"
            includeLastSlideInPeek
            device="mobile"
            endTracking="MotorsSpecsEnd"
            slides={attributeGroups.map(({ id, attributes, keyOnly }) => {
                const isStandardFeatures = id === 'cars4';
                const content = (
                    <Spacer key={id}>
                        <Card longerCard>
                            {!isStandardFeatures ? (
                                <Ul>
                                    {attributes.map(({ name, key, value, unit }) => (
                                        <Li key={key} keyOnly={keyOnly}>
                                            <LiInner keyOnly={keyOnly}>
                                                <Name keyOnly={keyOnly}>{name}</Name>
                                                {!keyOnly && (
                                                    <Value>
                                                        {value}
                                                        {unit && ` ${unit}`}
                                                    </Value>
                                                )}
                                            </LiInner>
                                        </Li>
                                    ))}
                                </Ul>
                            ) : (
                                <AdditionalFeaturesContainer>
                                    <StandardisedFeatures previewCount={8} hideTitle />
                                </AdditionalFeaturesContainer>
                            )}
                        </Card>
                    </Spacer>
                );

                return {
                    type: 'html',
                    content,
                };
            })}
            tabs={attributeGroups.map(({ id, label }) => [
                id,
                ({ dispatch, tabActive, tabCount, ...props }) => {
                    const tab = useCallback((node) => {
                        if (node) {
                            dispatch({
                                type: APPEND_WIDTH,
                                payload: node.getBoundingClientRect().width,
                                tabCount,
                            });
                        }
                    }, []);

                    return (
                        <TabTitle key={id} ref={tab} tabActive={tabActive} {...props}>
                            {label === 'Additional Features' ? 'Features' : label}
                        </TabTitle>
                    );
                },
            ])}
            tabContainer={TabContainer}
        />
    </StyleContainer>
);

export default MobileMotorsSpecs;
